import { render, staticRenderFns } from "./TablaSimulacion.vue?vue&type=template&id=f6836ee2&"
import script from "./TablaSimulacion.vue?vue&type=script&lang=js&"
export * from "./TablaSimulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports